@if ((isEnabled$ | async) && (isActivated$ | async)) {
  @if (route$ | async; as route) {
    <div class="d-inline-block float-end margin-right">
      <a target="_blank" rel="noopener noreferrer" [href]="route" class="btn btn-secondary"
        [title]="'feed.description' | translate" [attr.aria-label]="'feed.description' | translate" role="button" tabindex="0">
        <i class="fas fa-rss-square"></i>
      </a>
    </div>
  }
}
